export default (function () {
  var jackpotsSlider = new Swiper('.jackpots', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1
    },
    loop: true,
    slidesPerView: 'auto'
  });

  // let transformValue;
  // $('.jackpots-wrapper').hover(function() {
  //     jackpotsSlider.autoplay.stop();
  //
  //     //here you remember the translation, the swiper originally wanted to go
  //     transformValue = this.style.transform;
  //
  //     //then you set the transition duration on zero
  //
  //     this.style.transitionDuration = "0ms";
  //
  //     //then you set the wrapper translation hard on its current translation value
  //     //this might also work with swiper.setWrapperTranslate(swiper.getWrapperTranslate())
  //     this.style.transform = "translate3d(" + jackpotsSlider.getTranslate() + "px, 0px, 0px)";
  //
  // }, function() {
  //
  //     //here you set the transition duration back to it's original value
  //     this.style.transitionDuration = jackpotsSlider.params.speed + "ms";
  //
  //     //and give it back its originial destination
  //     this.style.transform = transformValue;
  //
  //     //then start autoplay again
  //     jackpotsSlider.autoplay.start();
  // });

  var eventsSlider = new Swiper('.events-slider', {
    spaceBetween: 14,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
      nextEl: '.events-swiper-button-next',
      prevEl: '.events-swiper-button-prev'
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      }
    }
  });
  var newsSlider = new Swiper('.news-slider', {
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
      nextEl: '.news-swiper-button-next',
      prevEl: '.news-swiper-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false
      }
    }
  });
  var boxGallerySlider = new Swiper('.box-gallery__slider', {
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    pagination: {
      el: '.box-gallery__swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function beforeInit() {
        var slides = this.el.querySelectorAll('.swiper-slide');
        if (slides) {
          this.params.loop = slides.length > 1;
          this.params.autoplay.enabled = slides.length > 1;
        }
      }
    }
  });
  var heroSlider = new Swiper('.hero', {
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    watchOverflow: true,
    autoplay: {
      delay: 9000
    },
    pagination: {
      el: '.hero__swiper-pagination',
      clickable: true
    },
    on: {
      beforeInit: function beforeInit() {
        var slides = this.el.querySelectorAll('.swiper-slide');
        if (slides) {
          this.params.loop = slides.length > 1;
          this.params.autoplay.enabled = slides.length > 1;
        }
      }
    }
  });
});